var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2218,16H1.7733c-0.6419,0-1.2182-0.326-1.5326-0.8867s-0.3275-1.2127,0-1.7734L7.4584,0.8867 C7.7859,0.339,8.3491,0,8.991,0s1.2182,0.326,1.5326,0.8867l7.2308,12.4532c0.3275,0.5476,0.3275,1.2127,0,1.7734 C17.4269,15.661,16.8636,16,16.2218,16z M8.5849,1.5387L1.3673,13.9918c-0.1179,0.2087-0.0393,0.3912,0,0.4695 c0.0393,0.0652,0.1572,0.2347,0.4061,0.2347h14.4485c0.2489,0,0.3668-0.1565,0.4061-0.2347c0.0393-0.0652,0.1178-0.2608,0-0.4695 L9.3971,1.5387C9.2792,1.3301,9.0696,1.304,8.991,1.304S8.7028,1.3301,8.5849,1.5387z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8746,10.742c-0.3641,0-0.6502-0.2861-0.6502-0.6503V5.9562c0-0.3641,0.2861-0.6502,0.6502-0.6502 c0.3641,0,0.6503,0.2861,0.6503,0.6502v4.1355C9.5249,10.4559,9.2387,10.742,8.8746,10.742z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8746,13.2129c-0.3641,0-0.6502-0.2861-0.6502-0.6502c0-0.3642,0.2861-0.6503,0.6502-0.6503 c0.3641,0,0.6503,0.2861,0.6503,0.6503c0,0.3641-0.2862,0.6632-0.6503,0.6632V13.2129z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b0244e07d4e9b5a520b14e92d7bac7f1.svg";
export { ForwardRef as ReactComponent };